// extracted by mini-css-extract-plugin
export default {"container":"_L-z","topReviewHeading":"aM-z","criticalReview":"bM-z","favorableReview":"cM-z","vsSeparator":"dM-z"};